import React, { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import Link from "next/link";
import { IoArrowForward, IoChevronForward } from "react-icons/io5";
import secondaryFont from "@/utils/secondaryFont";
import { useRouter } from "next/router";
import DesktopSubMenu from "./DesktopSubMenu";
import DesktopNormaLoansSubMenu from "./DesktopNormalLoansSubMenu";
import * as s from "../index.module.scss";

const NavLinks = ({ links, setExpanded, toggle, setToggle }) => {
  const [windowWidth, setWindowWidth] = useState(0);
  const [normalDropdown, setNormalDropdown] = useState(false);
  const { asPath } = useRouter();

  useEffect(() => {
    const updateWindowWidth = () => {
      setWindowWidth(window.innerWidth);
    };

    updateWindowWidth();
    window.addEventListener("resize", updateWindowWidth);

    return () => {
      window.removeEventListener("resize", updateWindowWidth);
    };
  }, []);

  return (
    <Nav
      className={`justify-content-end align-items-center flex-grow-1 pt-0 pt-lg-3 ${s.offcanvas_nav}`}
      as={"ul"}
    >
      {links?.map(({ title, link, subLinks, isNormalDropdown }, idx) => {
        const isDesktop = windowWidth > 1024;
        if (subLinks.length !== 0 && !isNormalDropdown) {
          return (
            <Nav.Link
              key={idx}
              className={`ps-0 pe-0 pe-lg-4 ${s.sub_links_wrapper}`}
              as={"li"}
              onMouseLeave={() => {
                if (isDesktop) setToggle(false);
              }}
              onMouseEnter={() => {
                if (isDesktop) setToggle(true);
              }}
            >
              <div className={`ps-lg-0 ${s.has_sub} ${toggle ? s.rotate : ""}`}>
                <Link
                  className={`${secondaryFont} ${
                    link === asPath ? "active" : ""
                  }`}
                  href={link}
                  onClick={(e) => {
                    if (!isDesktop) {
                      e.preventDefault();
                      setToggle(!toggle);
                    }
                  }}
                  style={{
                    borderBottom:
                      link === asPath && isDesktop
                        ? "2px solid #1570EF"
                        : "2px solid transparent",
                    // transition: 'border-color 0.3s',
                  }}
                  onMouseEnter={(e) => {
                    if (link != asPath && isDesktop) {
                      e.target.style.borderBottom = "2px solid #1570EF";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (link != asPath && isDesktop) {
                      e.target.style.borderBottom = "2px solid transparent";
                    }
                  }}
                >
                  {title}
                </Link>
                <IoChevronForward
                  size="22px"
                  onClick={() => {
                    setToggle(!toggle);
                  }}
                />
              </div>
              <div
                className={`${s.sub_links} ${s.mobile} ${
                  toggle ? s.show_sub_links : ""
                } pt-0 pb-0 ps-3`}
              >
                {subLinks.map(({ title, link }, index) => {
                  return (
                    <div className="border-0 pt-3 pb-3" key={index}>
                      <Link
                        href={link}
                        onClick={() => {
                          setExpanded(false);
                        }}
                      >
                        {title}
                      </Link>
                    </div>
                  );
                })}
                <div className={`border-0 pt-3 pb-3 ${s.last_sub_list}`}>
                  <Link
                    // className={`ps-0 d-lg-none btn b-0 d-flex gap-2 justify-content-start ${s.see_all_mobile_link}`}
                    className={`ps-0 d-lg-none b-0 d-flex gap-2 justify-content-start 
                    ${isDesktop ? "btn" : ""} ${s.see_all_mobile_link}`}
                    href="/what-we-buy"
                    onClick={() => {
                      setExpanded(false);
                    }}
                  >
                    <span className={`${s.span_txt}`}>Things We Buy</span>{" "}
                    <IoArrowForward size="18px" />
                  </Link>
                </div>
              </div>
              <div
                className={`${s.sub_links} ${s.desktop} ${
                  toggle ? s.show_sub_links : ""
                } pt-0 pb-0 ps-3`}
              >
                <DesktopSubMenu
                  subLinks={subLinks}
                  setExpanded={setExpanded}
                  toggle={toggle}
                  setToggle={setToggle}
                />
              </div>
            </Nav.Link>
          );
        } else if (subLinks.length !== 0 && isNormalDropdown) {
          return (
            <Nav.Link
              key={idx}
              className={`ps-0 pe-0 pe-lg-4 ${s.sub_links_wrapper} position-relative overflow-visible`}
              as={"li"}
              onMouseLeave={() => {
                if (isDesktop) setNormalDropdown(false);
              }}
              onMouseEnter={() => {
                if (isDesktop) setNormalDropdown(true);
              }}
            >
              <div
                className={`ps-lg-0 ${s.has_sub} ${normalDropdown ? s.rotate : ""}`}
              >
                <Link
                  className={`${secondaryFont} ${
                    link === asPath ? "active" : ""
                  }`}
                  href={link}
                  onClick={(e) => {
                    if (!isDesktop) {
                      e.preventDefault();
                      setNormalDropdown(!normalDropdown);
                    }
                  }}
                  style={{
                    borderBottom:
                      link === asPath && isDesktop
                        ? "2px solid #1570EF"
                        : "2px solid transparent",
                    // transition: 'border-color 0.3s',
                  }}
                  onMouseEnter={(e) => {
                    if (link != asPath && isDesktop) {
                      e.target.style.borderBottom = "2px solid #1570EF";
                    }
                  }}
                  onMouseLeave={(e) => {
                    if (link != asPath && isDesktop) {
                      e.target.style.borderBottom = "2px solid transparent";
                    }
                  }}
                >
                  {title}
                </Link>
                <IoChevronForward
                  size="22px"
                  onClick={() => {
                    setNormalDropdown(!normalDropdown);
                  }}
                />
              </div>
              <div
                className={`${s.sub_links} ${s.mobile} ${
                  normalDropdown ? s.show_sub_links : ""
                } pt-0 pb-0 ps-3`}
              >
                {subLinks.map(({ title, link }, index) => {
                  return (
                    <div className="border-0 pt-3 pb-3" key={index}>
                      <Link
                        href={link}
                        onClick={() => {
                          setExpanded(false);
                        }}
                      >
                        {title}
                      </Link>
                    </div>
                  );
                })}
              </div>
              <div
                className={`${s.sub_links} ${s.desktop} ${
                  toggle ? s.show_sub_links : ""
                } pt-0 pb-0 ps-3`}
              ></div>
              <div
                className={`${s.sub_links} ${s.sub_links_normal} ${s.desktop} ${
                  normalDropdown ? s.show_sub_links_normal : ""
                } pt-0 pb-0 ps-3`}
              >
                <DesktopNormaLoansSubMenu
                  subLinks={subLinks}
                  setExpanded={setExpanded}
                  toggle={normalDropdown}
                  setToggle={setNormalDropdown}
                />
              </div>
            </Nav.Link>
          );
        } else {
          return (
            <Nav.Link as={"li"} key={idx} className="mb-0 mb-lg-0 ms-lg-3">
              {/* <Link className={`${secondaryFont} ${s.no_sub} ${link === asPath ? 'active' : ''}`} href={link} onClick={() => { setExpanded(false) }}>
              {title} <ChevronForward />
            </Link> */}
              <Link
                className={`${secondaryFont} ${s.no_sub}`}
                href={link}
                onClick={() => {
                  setExpanded(false);
                }}
                style={{
                  borderBottom:
                    link === asPath && isDesktop
                      ? "2px solid #1570EF"
                      : "2px solid transparent",
                  // transition: 'border-color 0.3s',
                }}
                onMouseEnter={(e) => {
                  if (link != asPath && isDesktop) {
                    e.target.style.borderBottom = "2px solid #1570EF";
                  }
                }}
                onMouseLeave={(e) => {
                  if (link != asPath && isDesktop) {
                    e.target.style.borderBottom = "2px solid transparent";
                  }
                }}
              >
                {title}
                <IoChevronForward className="mob-icon" size="22px" />
              </Link>
            </Nav.Link>
          );
        }
      })}
      <li className="d-flex flex-row align-items-end">
        <Link
          className={`mb-0 mb-lg-0 ms-lg-5 btn btn-mob-full-w btn-primary mb-lg-0 d-md-inline ${s.btn_mod}`}
          href={"/get-a-loan"}
        >
          {"Get A Loan" + "  "}
          <IoArrowForward size="18px" />
        </Link>
      </li>
    </Nav>
  );
};

export default NavLinks;
